import api from '../main-api/apiClient';

// Tenant Doctor API services - for clinical review and patient care
export const tenantDoctorAPI = {
  // Patient Management for Clinical Review
  getPatients: () => api.get('/tenant-doctor/patients'),
  
  // Create Patient
  createPatient: (patientData) => {
    const formData = new FormData();
    Object.keys(patientData).forEach(key => {
      if (patientData[key] !== null && patientData[key] !== undefined && patientData[key] !== '') {
        formData.append(key, patientData[key]);
      }
    });
    return api.post('/patients', formData);
  },

  // Update Patient
  updatePatient: (patientId, patientData) => {
    const formData = new FormData();
    Object.keys(patientData).forEach(key => {
      if (patientData[key] !== null && patientData[key] !== undefined && patientData[key] !== '') {
        formData.append(key, patientData[key]);
      }
    });
    return api.put(`/patients/${patientId}`, formData);
  },
  
  // Vital Signs Review
  getPatientVitals: (patientId) => api.get(`/patients/${patientId}/vitals`),
  
  reviewVitalSigns: (vitalId, clinicalNotes, approvalStatus) => {
    const formData = new FormData();
    formData.append('clinical_notes', clinicalNotes);
    formData.append('approval_status', approvalStatus);
    return api.put(`/tenant-doctor/vitals/${vitalId}/review`, formData);
  },
  
  // Dashboard and Analytics
  getDashboardSummary: () => api.get('/tenant-doctor/dashboard/summary'),
  
  // Clinical Notes and Reviews
  addClinicalNotes: (patientId, notes) => {
    const formData = new FormData();
    formData.append('clinical_notes', notes);
    return api.post(`/tenant-doctor/patients/${patientId}/clinical-notes`, formData);
  },
  
  // Send Recording Link
  sendRecordingLink: (patientId, channel, message) => {
    const formData = new FormData();
    formData.append('channel', channel);
    if (message) {
      formData.append('custom_message', message);
    }
    return api.post(`/tenant-doctor/patients/${patientId}/send-recording-link`, formData);
  },

  // Twilio Voice Calling
  initiatePatientCall: (patientId) => {
    return api.post(`/patients/${patientId}/initiate-call`);
  }
};

export default tenantDoctorAPI;